import { Box, Typography } from '@material-ui/core'
import { Warning, Schedule } from '@material-ui/icons'
import { useStyles } from './styles'

interface IDashboardAlertsProps {
  ordersWithoutRoute: number
  ordersPendingStatus: number
}

export const DashboardAlerts = ({
  ordersWithoutRoute,
  ordersPendingStatus,
}: IDashboardAlertsProps) => {
  const classes = useStyles()

  const hasAlerts = ordersWithoutRoute > 0 || ordersPendingStatus > 0

  if (!hasAlerts) {
    return null
  }

  return (
    <Box className={classes.container}>
      {ordersWithoutRoute > 0 && (
        <Box className={classes.alertBox}>
          <Box className={classes.iconContainer}>
            <Warning className={classes.warningIcon} />
          </Box>
          <Box className={classes.alertContent}>
            <Typography className={classes.alertTitle}>Pedidos sem rota</Typography>
            <Typography className={classes.alertSubtitle}>
              {`${ordersWithoutRoute} pedido${ordersWithoutRoute > 1 ? 's' : ''}`}
            </Typography>
          </Box>
        </Box>
      )}

      {ordersPendingStatus > 0 && (
        <Box className={classes.alertBox}>
          <Box className={classes.iconContainer}>
            <Schedule className={classes.pendingIcon} />
          </Box>
          <Box className={classes.alertContent}>
            <Typography className={classes.alertTitle}>Aguardando aprovação</Typography>
            <Typography className={classes.alertSubtitle}>
              {`${ordersPendingStatus} pedido${ordersPendingStatus > 1 ? 's' : ''}`}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
}
